module.exports = __webpack_public_path__ + "img/LIVE-COVER.d1e21ed4.png";